import React from "react";

const ChatBot = () => {
    throw "Component Version Mismatch: You cannot use this config with this version of the app.";
};

export default ChatBot;
